module.exports = __webpack_public_path__ + "img/meteon.16b193f9.jpg";